import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import { enterKeyHandler, getTenant, getToken } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import DateRangeInput from '../DateRangeInput'
import FormSubmitButton from '../FormSubmitButton'
import ReportHeading from '../ReportHeading'

export default function BordereauxReportPDF({ location }) {
  console.log('BordereauxReportPDF rendered: ', location)

  const init = {
    client: '',
    dateFileOpenFrom: '',
    dateFileOpenTo: '',
    contractYear: '',
    claimStatus: '',
    assignedAttorney: '',
    reportType: '1'
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('OpenClaimsByAttorneyPDF.submitSearch', inputs)
    let validInput = true
    if (!inputs.contractYear) {
      validInput = false
    }
    if (!validInput) {
      return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}>Must select a contract year</Alert></td></tr>)
    }
    if (inputs.reportType === '1' || inputs.reportType === '2') {
      function tokenSuccess(jwt) {
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = `${process.env.REACT_APP_SERVER}/pdf/${getTenant()}/custom/Bisc/bordereauxReportPDF/bordereaux_report?inputs=${JSON.stringify(inputs)}&jwt=${jwt}`
        link.setAttribute('type', 'hidden')
        link.setAttribute('target', '_blank')
        link.click()
      }
      function tokenError(error) {
        console.log('PDFLink: ', JSON.stringify(error))
      }
      getToken(tokenSuccess, tokenError)
    } else {
      let queryString = `/custom/reports.bordereaux?inputs=${JSON.stringify(inputs)}`
      navigate(queryString)
    }
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <ReportHeading title='Bordereaux Report' showReportDate={false} widths={['0%', '100%', '0%']} />
            {formFeedback}
            <tbody>
              <CustomSelectListInput label="Client" name='client' handleChange={handleInputChange} modelName='Bisc' entityName='client' />
              <DateRangeInput label='Date File Open' name='dateFileOpen' handleInputChange={handleInputChange} />
              <CustomSelectListInput label="Contract Year" name='contractYear' handleChange={handleInputChange} modelName='Bisc' entityName='contractYear' blankOption={true} />
              <tr>
                <td style={{ verticalAlign: 'middle' }} ><b>Claim Status</b></td>
                <td>
                  <Input type="select" name="claimStatus" onChange={handleInputChange} style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}>
                    <option value={''}></option>
                    <option value={'3260'}>Closed</option>
                    <option value={'3250'}>Open</option>
                  </Input>
                </td>
              </tr>
              <CustomSelectListInput label="Assigned Attorney" name='assignedAttorney' handleChange={handleInputChange} modelName='Bisc' entityName='assignedAttorney' />
              <tr>
                <td style={{ verticalAlign: 'middle' }} ><b>Report Type</b></td>
                <td>
                  <Input type="select" name="reportType" onChange={handleInputChange} style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}>
                    <option value={'1'}>Preliminary (Internal)</option>
                    <option value={'2'}>Final</option>
                    <option value={'3'}>Electronic (HTML)</option>
                  </Input>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Run Report" />
      </form>
    </div>
  )
}

